import {
    gsap,
    ScrollTrigger,
} from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

export default () => {
    const trackingButton = document.querySelector(".tracking-button");
    const postItemImg = document.querySelector(".post-item-img");
    const postCta = document.querySelector(".post-cta");
    gsap.from(trackingButton, {
        autoAlpha: 0,
        y: 40,
        ease: "power4.Out",
        duration: "0.3",
        scrollTrigger: {
            trigger: postItemImg,
            start: "bottom 50%",
            toggleActions: "play none none reverse",
        },
    });
    
    gsap.to(trackingButton, {
        autoAlpha: 0,
        y: 40,
        ease: "power4.Out",
        duration: "0.3",
        scrollTrigger: {
            immediateRender: false,
            trigger: postCta,
            start: "top 80%",
            toggleActions: "play none none reverse",
        },
    });
}